import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "splitFilter",
  pure: false
})
export class SplitFilterPipe implements PipeTransform {
  transform(value: any, delimiter: string = " ", indexOf: number = 0): any {
    try {
      if (!value || value == "" || value == null) {
        return "";
      }

      if (isNaN(indexOf)) {
        indexOf = 0;
      }
      return value.split(delimiter)[indexOf];
    } catch (e) {}
  }
}
